import { render } from "./App.vue?vue&type=template&id=541b498d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/yang/wms-image/wms-image-pc/Commodity_Wms_Pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__